import React from 'react'

function Notfound() {
  return (
    <div>Page not found....</div>
  )
}

export default Notfound;